// app/global-error.tsx
"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // Report render-time failures that occur before/around the root layout
    Sentry.captureException(error);

    console.error(error);
  }, [error]);

  // Minimal UI; layout isn't available if it crashed
  return (
    <html lang="en">
      <body style={{ padding: 24 }}>
        <h1 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Something went wrong</h1>
        <p style={{ fontSize: 14, opacity: 0.8 }}>
          The app shell failed to render. Please refresh and try again.
        </p>
      </body>
    </html>
  );
}
